import { createJSONRequest } from './create-request'

export const fetchTransitionPulseMonths = () => createJSONRequest({
  url: '/api/transition-reports',
  method: 'GET',
})

export const fetchTransitionPulse = (id: number) => createJSONRequest({
  url: `/api/transition-reports/${id}`,
  method: 'GET',
})
